import { RemoveRedEye } from "@mui/icons-material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadEstructuraArchivo,
} from "../../../../../redux/actions/nte";
import PdfDialog from "../../../../commons/file/PdfDialog";
import FeatureLabel from "../labels/FeatureLabel";

const InformacionImportarArchivoContainer = () => {
  const dispatch = useDispatch();
  const visualizarArchivoInstrucciones = useSelector(
    (state) => state.nte.descargarEstructuraArchivo.data?.base64
  );
  const [openInformacionArchivoImportar, setOpenInformacionArchivoImportar] =
    useState(false);

  const handleViewInstruccionesImportar = () => {
    setOpenInformacionArchivoImportar(true);
    dispatch(downloadEstructuraArchivo());
  };
  return (

    <>
      <FeatureLabel
        labelText="INFORMACIÓN DEL ARCHIVO A IMPORTAR"
        icon={<RemoveRedEye />}
        onClick={handleViewInstruccionesImportar}
        tooltipText="Ver Información"
      />
      <PdfDialog
        open={openInformacionArchivoImportar}
        title="Estructura archivo"
        handleClose={() => setOpenInformacionArchivoImportar(false)}
        controllers={true}
        file={visualizarArchivoInstrucciones}
      />
    </>
  )
}


export default InformacionImportarArchivoContainer;